import { offers } from "./data"


export async function getSpeciallOffers() {
    return offers
} 